module.exports = __webpack_public_path__ + "static/media/GERSAssessment.7d5da6a9.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offers/Contents/GERSAssessment.md
// module id = 969
// module chunks = 0